import i18n from 'src/config/i18n';
import { httpClient } from 'src/config/http';
import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';

import { config } from 'src/config/config';
import { GoalInterest } from '../models/goals';

export class GoalsService {
    constructor(private toastNotificationsService: ToastNotificationsService) {}

    public async fetchGoalInterests(): Promise<GoalInterest[] | void> {
        try {
            return await httpClient.GET<GoalInterest[]>('goals/interests/');
        } catch {
            this.toastNotificationsService.renderErrorToast(
                i18n.t('goals:failed_to_fetch_interests'),
            );
        }
    }

    public async saveGoalsInterests(ids: number[]): Promise<GoalInterest[]> {
        try {
            const interests = await httpClient.PUT<GoalInterest[], { goalCategory: number }[]>(
                'goals/interests/',
                ids.map(id => ({ goalCategory: id })),
            );

            return interests;
        } catch {
            this.toastNotificationsService.renderErrorToast(i18n.t(config.messages.genericError));

            return [];
        }
    }
}
